var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157145",
    "data-name": "Rectangle 157145",
    width: 38,
    height: 38,
    rx: 8,
    transform: "translate(38) rotate(90)",
    fill: "#fff",
    stroke: "#e8eaee",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157085",
    "data-name": "Rectangle 157085",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "settings_20dp_5F6368_FILL0_wght400_GRAD0_opsz20",
    d: "M129.092-844.945a1.087,1.087,0,0,1-.72-.248,1.069,1.069,0,0,1-.372-.645l-.372-1.935a8.987,8.987,0,0,1-1.1-.521,6.393,6.393,0,0,1-1-.695l-1.861.645a1.133,1.133,0,0,1-.757-.012,1.056,1.056,0,0,1-.583-.484l-.992-1.737a1.035,1.035,0,0,1-.124-.732,1.175,1.175,0,0,1,.372-.657l1.464-1.29q-.05-.3-.074-.6t-.025-.62q0-.323.025-.62t.074-.6l-1.464-1.29a1.176,1.176,0,0,1-.372-.657,1.035,1.035,0,0,1,.124-.732l.992-1.737a1.056,1.056,0,0,1,.583-.484,1.132,1.132,0,0,1,.757-.012l1.861.645a6.4,6.4,0,0,1,1-.695,8.978,8.978,0,0,1,1.1-.521l.372-1.935a1.069,1.069,0,0,1,.372-.645,1.087,1.087,0,0,1,.72-.248h1.985a1.087,1.087,0,0,1,.72.248,1.069,1.069,0,0,1,.372.645l.372,1.935a8.977,8.977,0,0,1,1.1.521,6.4,6.4,0,0,1,1,.695l1.861-.645a1.132,1.132,0,0,1,.757.012,1.056,1.056,0,0,1,.583.484l.992,1.737a1.035,1.035,0,0,1,.124.732,1.176,1.176,0,0,1-.372.657l-1.464,1.29q.05.3.074.6t.025.62q0,.323-.025.62t-.074.6l1.464,1.29a1.175,1.175,0,0,1,.372.657,1.035,1.035,0,0,1-.124.732l-.992,1.737a1.056,1.056,0,0,1-.583.484,1.133,1.133,0,0,1-.757.012l-1.861-.645a6.393,6.393,0,0,1-1,.695,8.986,8.986,0,0,1-1.1.521l-.372,1.935a1.069,1.069,0,0,1-.372.645,1.087,1.087,0,0,1-.72.248Zm.546-1.786h.893l.471-2.456a5.5,5.5,0,0,0,1.762-.645,5.166,5.166,0,0,0,1.414-1.191l2.382.794.447-.744-1.886-1.662a5.987,5.987,0,0,0,.236-.881,5.128,5.128,0,0,0,.087-.955,5.128,5.128,0,0,0-.087-.955,5.989,5.989,0,0,0-.236-.881l1.886-1.662-.447-.744-2.382.794a5.167,5.167,0,0,0-1.414-1.191,5.5,5.5,0,0,0-1.762-.645l-.471-2.456h-.893l-.471,2.456a5.5,5.5,0,0,0-1.762.645,5.167,5.167,0,0,0-1.414,1.191l-2.382-.794-.447.744,1.886,1.662a5.989,5.989,0,0,0-.236.881,5.13,5.13,0,0,0-.087.955,5.129,5.129,0,0,0,.087.955,5.987,5.987,0,0,0,.236.881l-1.886,1.662.447.744,2.382-.794a5.166,5.166,0,0,0,1.414,1.191,5.5,5.5,0,0,0,1.762.645Zm.447-4.168a3.446,3.446,0,0,0,2.531-1.042,3.446,3.446,0,0,0,1.042-2.531A3.446,3.446,0,0,0,132.615-857a3.446,3.446,0,0,0-2.531-1.042A3.446,3.446,0,0,0,127.554-857a3.446,3.446,0,0,0-1.042,2.531,3.446,3.446,0,0,0,1.042,2.531A3.446,3.446,0,0,0,130.085-850.9ZM130.085-854.472Z",
    transform: "translate(-118.084 866.716)",
    fill: "#2e4d7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIconWhite);
export default __webpack_public_path__ + "static/media/SettingIconWhite.876c234767724861d72e9b3c5ea65160.svg";
export { ForwardRef as ReactComponent };